export default class Empresa  {
    RAZONSC:string="";
    RNCEMPR:string="";
    
}